"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

require("./message-bubble.scss");

var MessageTypes;

(function (MessageTypes) {
  MessageTypes["primary"] = "primary";
  MessageTypes["light"] = "light";
  MessageTypes["dark"] = "dark";
})(MessageTypes || (MessageTypes = {}));

exports.MessageTypes = MessageTypes;

var MessageBubble = function MessageBubble(_a) {
  var message = _a.message,
      type = _a.type;
  return react_1["default"].createElement("div", {
    className: "message-bubble " + type
  }, message);
};

exports.MessageBubble = MessageBubble;
MessageBubble.defaultProps = {
  type: MessageTypes.primary
};